// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ad80d810","977":"65e7e607"}[chunkId] + ".chunk.js";
};